'use es6';

import { createSelector } from 'reselect';
import { Map as ImmutableMap } from 'immutable';
import { getCampaignIdFromParams } from './PropsSelectors';
import FBBreakdownFunnelRecord from 'AdsUI/records/analyze/FBBreakdownFunnelRecord';

const getEmptyRecord = (publisherPlatform, impressionDevice) => FBBreakdownFunnelRecord({
  publisherPlatform,
  impressionDevice,
  clicks: 0,
  impressions: 0,
  cost: 0,
  reach: 0
});

export const getAllBreakdownFunnels = state => state.fbBreakdownFunnels;
export const fbBreakdownFunnelsSelector = createSelector(getAllBreakdownFunnels, getCampaignIdFromParams, (funnels, campaignId) => {
  return funnels.get(campaignId);
});
export const getProcessedFbBreakdownFunnels = createSelector(fbBreakdownFunnelsSelector, campaignBreakdowns => {
  if (!campaignBreakdowns || campaignBreakdowns.size === 0) {
    return campaignBreakdowns;
  } // Ensure that every category has data


  const devices = campaignBreakdowns.map(breakdown => breakdown.impressionDevice).toSet();
  const platforms = campaignBreakdowns.map(breakdown => breakdown.publisherPlatform).toSet();
  return platforms.reduce((breakdowns, platform) => breakdowns.set(platform, devices.map(device => campaignBreakdowns.find(breakdown => breakdown.publisherPlatform === platform && breakdown.impressionDevice === device) || getEmptyRecord(platform, device)).sortBy(item => -item.reach)), ImmutableMap()).sortBy(platformData => -platformData.reduce((totalReach, data) => totalReach + data.reach, 0));
});